(function() {
  'use strict';

  function debounce(callback, delay) {
    var timer = null;

    return function() {
      window.clearTimeout(timer);
      timer = window.setTimeout(function() {
        timer = null;
        callback();
      }, delay);
    };
  }

  function detectIosSafari() {
    var ua = window.navigator.userAgent;
    var platform = window.navigator.platform;
    var isAppleTouchDesktop = platform === 'MacIntel' && window.navigator.maxTouchPoints > 1;
    var isIos = /iPad|iPhone|iPod/.test(ua) || isAppleTouchDesktop;
    var isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS/.test(ua);

    return isIos && isSafari;
  }

  function wait(delay) {
    return new Promise(function(resolve) {
      window.setTimeout(resolve, delay);
    });
  }

  function getFullscreenElement() {
    return document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement ||
      null;
  }

  function setControls(launchButton, restartButton, closeButton, fullscreenButton, clearCacheButton, isRunning) {
    launchButton.disabled = isRunning;
    restartButton.disabled = !isRunning;
    closeButton.disabled = !isRunning;
    fullscreenButton.disabled = !isRunning;
    clearCacheButton.disabled = !isRunning;
  }

  function setControlsForState(launchButton, restartButton, closeButton, fullscreenButton, clearCacheButton, state) {
    var isRunnable = state === 'running';
    var isIdle = state === 'idle';
    var canClose = state === 'running' || state === 'launching' || state === 'failed';

    launchButton.disabled = !isIdle;
    restartButton.disabled = !isRunnable;
    closeButton.disabled = !canClose;
    fullscreenButton.disabled = !isRunnable;
    clearCacheButton.disabled = !isRunnable;
  }

  function setIconButtonContent(button, iconClassName, label) {
    var icon = document.createElement('span');

    icon.className = iconClassName;
    button.textContent = '';
    button.appendChild(icon);
    button.appendChild(document.createTextNode(' ' + label));
  }

  function buildDemoSrc(src, query) {
    if (!query) {
      return src;
    }

    return src + (src.indexOf('?') === -1 ? '?' : '&') + query;
  }

  function buildLifecycleStorageKey(demo) {
    return 'game-html5:lifecycle:' + (demo.getAttribute('data-demo-src') || window.location.pathname);
  }

  function buildLifecycleHistoryStorageKey(demo) {
    return 'game-html5:lifecycle-history:' + (demo.getAttribute('data-demo-src') || window.location.pathname);
  }

  function createLifecycleLogger(demo) {
    var sessionKey = buildLifecycleStorageKey(demo);
    var historyKey = buildLifecycleHistoryStorageKey(demo);
    var maxEntries = 120;
    var maxHistoryEntries = 300;
    var maxHistoryChars = 150000;
    var sessionId = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);

    function readStorage(storage, key) {
      try {
        var parsed = JSON.parse(storage.getItem(key) || '[]');
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    }

    function writeStorage(storage, key, entries, maxCount, maxChars) {
      var safeEntries = entries.slice(-maxCount);

      try {
        while (safeEntries.length && JSON.stringify(safeEntries).length > maxChars) {
          safeEntries.shift();
        }

        storage.setItem(key, JSON.stringify(safeEntries));
      } catch (error) {
        // Storage can fail in private browsing or low-storage browser modes.
      }
    }

    function readEntries() {
      return readStorage(window.sessionStorage, sessionKey);
    }

    function readHistory() {
      return readStorage(window.localStorage, historyKey);
    }

    function writeEntries(entries) {
      writeStorage(window.sessionStorage, sessionKey, entries, maxEntries, 60000);
    }

    function writeHistory(entries) {
      writeStorage(window.localStorage, historyKey, entries, maxHistoryEntries, maxHistoryChars);
    }

    function log(eventName, detail) {
      var entries = readEntries();
      var history = readHistory();
      var entry = {
        event: eventName,
        detail: detail || '',
        time: new Date().toISOString(),
        visibility: document.visibilityState || '',
        session: sessionId
      };

      entries.push(entry);
      history.push(entry);

      writeEntries(entries);
      writeHistory(history);
    }

    log('page-ready', window.location.href);

    return {
      key: sessionKey,
      historyKey: historyKey,
      session: sessionId,
      log: log,
      read: readEntries,
      readHistory: readHistory
    };
  }

  function getFullscreenRequest(element) {
    return element.requestFullscreen ||
      element.webkitRequestFullscreen ||
      element.mozRequestFullScreen ||
      element.msRequestFullscreen ||
      null;
  }

  function injectResponsiveStyles(iframe) {
    var iframeDocument;

    try {
      iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
    } catch (error) {
      return;
    }

    if (!iframeDocument || iframeDocument.querySelector('[data-game-html5-responsive-style]')) {
      return;
    }

    var style = iframeDocument.createElement('style');
    style.setAttribute('data-game-html5-responsive-style', '');
    style.textContent = [
      'html, body {',
      '  width: 100% !important;',
      '  height: 100% !important;',
      '  margin: 0 !important;',
      '  overflow: hidden !important;',
      '  background: #000 !important;',
      '}',
      '.container, .wrapper {',
      '  min-width: 0 !important;',
      '  max-width: none !important;',
      '}',
      '#mainarea {',
      '  position: absolute !important;',
      '  inset: 0 !important;',
      '  width: 100% !important;',
      '  height: 100% !important;',
      '  min-width: 0 !important;',
      '  max-width: none !important;',
      '  margin: 0 !important;',
      '  overflow: hidden !important;',
      '}',
      '#canvas {',
      '  width: 100% !important;',
      '  height: 100% !important;',
      '  max-width: none !important;',
      '  margin: 0 !important;',
      '  object-fit: contain !important;',
      '}',
      '.buttonarea, #buttonarea, #buttonarea.buttonarea {',
      '  display: none !important;',
      '}',
      '@font-face {',
      '  font-family: "Glyphicons Halflings";',
      '  src: url("fonts/glyphicons-halflings-regular.woff2") format("woff2"),',
      '       url("fonts/glyphicons-halflings-regular.woff") format("woff"),',
      '       url("fonts/glyphicons-halflings-regular.ttf") format("truetype");',
      '}',
      '.glyphicon {',
      '  font-family: "Glyphicons Halflings" !important;',
      '  font-style: normal !important;',
      '  font-weight: 400 !important;',
      '  line-height: 1 !important;',
      '  speak: none !important;',
      '  text-transform: none !important;',
      '  -webkit-font-smoothing: antialiased !important;',
      '  -moz-osx-font-smoothing: grayscale !important;',
      '}'
    ].join('\n');

    (iframeDocument.head || iframeDocument.documentElement).appendChild(style);
  }

  function requestIframeRelayout(iframe) {
    if (!iframe || !iframe.contentWindow) {
      return;
    }

    try {
      injectResponsiveStyles(iframe);

      if (iframe.contentWindow.Module && iframe.contentWindow.Module.UE4_resizeCanvas) {
        iframe.contentWindow.Module.UE4_resizeCanvas();
      }

      iframe.contentWindow.dispatchEvent(new Event('resize'));
    } catch (error) {
      // Cross-origin or partially loaded frames cannot always be controlled from the parent page.
    }
  }

  function requestSettledIframeRelayout(iframe) {
    requestIframeRelayout(iframe);

    window.requestAnimationFrame(function() {
      requestIframeRelayout(iframe);
    });

    window.setTimeout(function() {
      requestIframeRelayout(iframe);
    }, 150);
  }

  function initializeDemo(demo) {
    var demoSrc = demo.getAttribute('data-demo-src');
    var demoQuery = demo.getAttribute('data-demo-query') || '';
    var iframeTitle = demo.getAttribute('data-iframe-title') || 'Playable HTML5 build';
    var frame = demo.querySelector('.game-html5__frame');
    var launchButton = demo.querySelector('.game-html5__launch');
    var restartButton = demo.querySelector('.game-html5__restart');
    var closeButton = demo.querySelector('.game-html5__close');
    var fullscreenButton = demo.querySelector('.game-html5__fullscreen');
    var clearCacheButton = demo.querySelector('.game-html5__clear-cache');
    var exitFullscreenButton = demo.querySelector('.game-html5__exit-fullscreen');
    var placeholder = frame ? frame.innerHTML : '';
    var activeIframe = null;
    var isSoftFullscreen = false;
    var state = 'idle';
    var closeSequence = Promise.resolve();
    var launchTimeoutId = 0;
    var isIosSafari = detectIosSafari();
    var closeCooldown = isIosSafari ? 2500 : 500;
    var logger = createLifecycleLogger(demo);
    var iframeDebugErrorCount = 0;
    var ueStartupBannerCount = 0;
    var lastIframeDebugErrorAt = 0;
    var iosFailureCloseTimer = 0;

    if (!demoSrc || !frame || !launchButton || !restartButton || !closeButton || !fullscreenButton || !clearCacheButton || !exitFullscreenButton) {
      return;
    }

    demo.setAttribute('data-game-html5-lifecycle-key', logger.key);
    demo.setAttribute('data-game-html5-lifecycle-history-key', logger.historyKey);

    var relayoutActiveIframe = debounce(function() {
      if (state === 'closing' || state === 'cooldown' || state === 'idle') {
        return;
      }

      requestSettledIframeRelayout(activeIframe);
    }, 50);

    function setState(nextState, detail) {
      state = nextState;
      demo.setAttribute('data-game-html5-state', state);
      setControlsForState(launchButton, restartButton, closeButton, fullscreenButton, clearCacheButton, state);
      logger.log('state:' + state, detail);
    }

    function restorePlaceholder() {
      activeIframe = null;
      frame.innerHTML = placeholder;
    }

    function clearLaunchTimeout() {
      window.clearTimeout(launchTimeoutId);
      launchTimeoutId = 0;
    }

    function clearIosFailureCloseTimer() {
      window.clearTimeout(iosFailureCloseTimer);
      iosFailureCloseTimer = 0;
    }

    function scheduleIosFailureClose(reason) {
      if (!isIosSafari || state === 'closing' || state === 'cooldown' || state === 'idle') {
        return;
      }

      logger.log('ios-failure-close-scheduled', reason);
      setState('failed', reason);
      clearIosFailureCloseTimer();
      iosFailureCloseTimer = window.setTimeout(function() {
        iosFailureCloseTimer = 0;
        closeDemo();
      }, 900);
    }

    function waitForIframeBlank(iframe, timeout) {
      return new Promise(function(resolve) {
        var isResolved = false;
        var timeoutId;

        function done(result) {
          if (isResolved) {
            return;
          }

          isResolved = true;
          window.clearTimeout(timeoutId);
          iframe.removeEventListener('load', onLoad);
          resolve(result);
        }

        function onLoad() {
          done('blank-load');
        }

        timeoutId = window.setTimeout(function() {
          done('blank-timeout');
        }, timeout);

        iframe.addEventListener('load', onLoad);

        try {
          iframe.src = 'about:blank';
        } catch (error) {
          done('blank-error');
        }
      });
    }

    function launchDemo() {
      if (state !== 'idle' && state !== 'failed') {
        logger.log('launch-ignored', state);
        return closeSequence;
      }

      clearLaunchTimeout();
      clearIosFailureCloseTimer();
      iframeDebugErrorCount = 0;
      ueStartupBannerCount = 0;
      lastIframeDebugErrorAt = 0;
      setState('launching');

      var iframe = document.createElement('iframe');

      frame.innerHTML = '';
      iframe.title = iframeTitle;
      iframe.src = buildDemoSrc(demoSrc, demoQuery);
      iframe.allow = 'fullscreen; gamepad; autoplay; xr-spatial-tracking';
      iframe.addEventListener('load', function() {
        if (activeIframe !== iframe || state === 'closing' || state === 'cooldown') {
          return;
        }

        logger.log('iframe-load', iframe.src);
        clearLaunchTimeout();
        setState('running');
        relayoutActiveIframe();
      });
      iframe.addEventListener('error', function() {
        if (activeIframe !== iframe) {
          return;
        }

        logger.log('iframe-error', iframe.src);
        clearLaunchTimeout();
        setState('failed');
      });

      frame.appendChild(iframe);
      frame.appendChild(exitFullscreenButton);
      activeIframe = iframe;
      relayoutActiveIframe();

      launchTimeoutId = window.setTimeout(function() {
        if (activeIframe === iframe && state === 'launching') {
          logger.log('launch-timeout', iframe.src);
          setState('failed');
        }
      }, isIosSafari ? 30000 : 20000);
    }

    function closeDemo() {
      if (state === 'idle' || state === 'closing' || state === 'cooldown') {
        logger.log('close-ignored', state);
        return closeSequence;
      }

      var iframe = activeIframe;

      setState('closing');
      clearLaunchTimeout();
      clearIosFailureCloseTimer();
      exitFullscreenMode();

      closeSequence = Promise.resolve()
        .then(function() {
          if (!iframe) {
            return 'no-iframe';
          }

          return waitForIframeBlank(iframe, isIosSafari ? 2000 : 750);
        })
        .then(function(result) {
          logger.log('iframe-blanked', result);

          if (activeIframe === iframe) {
            restorePlaceholder();
          }

          setState('cooldown', String(closeCooldown));
          return wait(closeCooldown);
        })
        .then(function() {
          setState('idle');
        });

      return closeSequence;
    }

    function restartDemo() {
      if (state !== 'running') {
        logger.log('restart-ignored', state);
        return;
      }

      logger.log('restart-requested');
      closeDemo().then(launchDemo);
    }

    function exitNativeFullscreen() {
      var fullscreenElement = getFullscreenElement();

      if (fullscreenElement) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }

        return true;
      }

      return false;
    }

    function setSoftFullscreen(isEnabled) {
      isSoftFullscreen = isEnabled;
      frame.classList.toggle('game-html5__frame--soft-fullscreen', isEnabled);
      setFullscreenButton(isEnabled);

      if (state === 'running' || state === 'launching') {
        relayoutActiveIframe();
      }
    }

    function exitFullscreenMode() {
      if (isSoftFullscreen) {
        setSoftFullscreen(false);
      }

      exitNativeFullscreen();
    }

    function enterFullscreenMode() {
      var requestFullscreen = getFullscreenRequest(frame);

      if (!requestFullscreen) {
        setSoftFullscreen(true);
        return;
      }

      var result;

      try {
        result = requestFullscreen.call(frame);
      } catch (error) {
        setSoftFullscreen(true);
        return;
      }

      if (result && result.catch) {
        result.catch(function() {
          setSoftFullscreen(true);
        });
      }

      window.setTimeout(function() {
        if (!getFullscreenElement() && !isSoftFullscreen) {
          setSoftFullscreen(true);
        }
      }, 250);
    }

    function toggleFullscreen() {
      if (getFullscreenElement() || isSoftFullscreen) {
        exitFullscreenMode();
        return;
      }

      enterFullscreenMode();
    }

    function updateFullscreenButton() {
      var fullscreenElement = getFullscreenElement();

      if (!fullscreenElement && !isSoftFullscreen) {
        setFullscreenButton(false);
      } else if (fullscreenElement) {
        setFullscreenButton(true);
      }

      if (state === 'running' || state === 'launching') {
        relayoutActiveIframe();
      }
    }

    function setFullscreenButton(isExit) {
      setIconButtonContent(
        fullscreenButton,
        isExit ? 'font-icon--interface--fullscreen-disable' : 'font-icon--interface--fullscreen-enable',
        isExit ? 'Exit Fullscreen' : 'Fullscreen'
      );
    }

    function clearCache() {
      if (!activeIframe || !activeIframe.contentWindow) {
        return;
      }

      logger.log('clear-cache-requested');

      try {
        if (activeIframe.contentWindow.deleteIndexedDBStorage) {
          activeIframe.contentWindow.deleteIndexedDBStorage();
        }
      } catch (error) {
        // Some failed or partially loaded UE frames may not expose cache helpers yet.
      }

      closeDemo();
    }

    function getIframeDebugMessage(entry) {
      if (!entry || typeof entry !== 'object') {
        return '';
      }

      if (typeof entry.message === 'string' && entry.message) {
        return entry.message;
      }

      if (Array.isArray(entry.args)) {
        return entry.args.map(function(value) {
          if (typeof value === 'string') {
            return value;
          }

          if (value && typeof value.message === 'string') {
            return value.message;
          }

          try {
            return JSON.stringify(value);
          } catch (error) {
            return String(value);
          }
        }).join(' ');
      }

      return '';
    }

    function handleIframeDebugMessage(event) {
      if (!activeIframe || !activeIframe.contentWindow || event.source !== activeIframe.contentWindow) {
        return;
      }

      var data = event.data;
      var entry = data && data.type === 'synticore-debug-log' ? data.entry : null;

      if (!entry) {
        return;
      }

      var message = getIframeDebugMessage(entry);

      if (message.indexOf('Fork of Unreal Engine') !== -1) {
        ueStartupBannerCount += 1;
        logger.log('iframe-ue-startup-banner', String(ueStartupBannerCount));

        if (isIosSafari && ueStartupBannerCount > 1) {
          scheduleIosFailureClose('duplicate-ue-startup-banner');
        }
      }

      if (entry.level === 'error' || entry.source === 'error' || entry.source === 'unhandledrejection') {
        iframeDebugErrorCount += 1;
        lastIframeDebugErrorAt = Date.now();
        logger.log('iframe-debug-error', message || entry.source || entry.level || 'error');

        if (isIosSafari && iframeDebugErrorCount >= 2) {
          scheduleIosFailureClose('repeated-iframe-debug-error');
        }
      }
    }

    window.addEventListener('pagehide', function(event) {
      logger.log('pagehide', event.persisted ? 'persisted' : '');
    });

    window.addEventListener('pageshow', function(event) {
      logger.log('pageshow', event.persisted ? 'persisted' : '');
    });

    document.addEventListener('visibilitychange', function() {
      logger.log('visibilitychange', document.visibilityState || '');

      if (
        isIosSafari &&
        document.visibilityState === 'hidden' &&
        activeIframe &&
        (state === 'running' || state === 'launching') &&
        lastIframeDebugErrorAt &&
        Date.now() - lastIframeDebugErrorAt < 5000
      ) {
        logger.log('ios-hidden-after-iframe-error', state);
      }
    });

    window.addEventListener('message', handleIframeDebugMessage);
    launchButton.addEventListener('click', launchDemo);
    restartButton.addEventListener('click', restartDemo);
    closeButton.addEventListener('click', closeDemo);
    fullscreenButton.addEventListener('click', toggleFullscreen);
    clearCacheButton.addEventListener('click', clearCache);
    exitFullscreenButton.addEventListener('click', exitFullscreenMode);
    document.addEventListener('fullscreenchange', updateFullscreenButton);
    document.addEventListener('webkitfullscreenchange', updateFullscreenButton);
    document.addEventListener('mozfullscreenchange', updateFullscreenButton);
    document.addEventListener('MSFullscreenChange', updateFullscreenButton);
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && isSoftFullscreen) {
        setSoftFullscreen(false);
      }
    });

    if (window.ResizeObserver) {
      new ResizeObserver(relayoutActiveIframe).observe(frame);
    } else {
      window.addEventListener('resize', relayoutActiveIframe);
    }

    setState('idle');
    setFullscreenButton(false);
  }

  document.querySelectorAll('.game-html5').forEach(initializeDemo);
})();
